import { Line } from "../types/types";

type InputBoardProps = {
  lines: Line[]; // строки со своим значением и состоянием
  setLines: React.Dispatch<React.SetStateAction<Line[]>>;
  activeLine: number; // текущая отгадываемая строка
  checkLine: (index: number) => void;
  setMessage:  React.Dispatch<React.SetStateAction<string>>;
};

const InputBoard: React.FC<InputBoardProps> = ({
  lines,
  setLines,
  activeLine,
  checkLine,
  setMessage,
}) => {
  return (
    <>
      {lines.map((line, index) => (
        <input
          key={index}
          className={`transpos-input-line transpos-${line.status}`}
          value={line.value}
          disabled={index !== activeLine || line.status === "correct"}
          onFocus={() => {
            setMessage("");
            const copy = [...lines];
            copy[index].status = "active";
            setLines(copy);
          }}
          onBlur={() => {
            const copy = [...lines];

            if (copy[index].status === "active") {
              copy[index].status = "idle";
              setLines(copy);
            }
          }}
          onChange={(e) => {
            const copy = [...lines];

            copy[index].value = e.target.value;

            if (copy[index].status !== "correct") {
              copy[index].status = "active";
            }

            setLines(copy);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();

              checkLine(index);

              event.currentTarget.blur();
            }
          }}
        />
      ))}
    </>
  );
};

export default InputBoard;
